/* eslint-disable no-case-declarations */
import {i18nKey} from '@/locales/i18n';
import {message} from 'antd';
import {t} from 'i18next';

const useMessage = () => {
  const success = (content: string, duration = 3) => {
    message.success({
      content,
      duration,
      className: 'success-message-custom',
    });
  };

  const error = (content: string, duration = 3) => {
    message.error({
      content,
      duration,
      className: 'error-message-custom',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const errorByStatusCode = (statusCode?: number, data: any = {}) => {
    console.log('StatusCode', statusCode);
    console.log('Data', data);
    switch (statusCode) {
      case 1003:
        const remainPageCount = data?.remainPageCount;
        if (remainPageCount && remainPageCount > 0) {
          error(
            t(i18nKey.common.apiErrorMessages.errorCode1003a, {
              pageCount: remainPageCount,
            }),
          );
        } else {
          error(t(i18nKey.common.apiErrorMessages.errorCode1003b));
        }

        break;
      case 3000:
        error(t(i18nKey.common.apiErrorMessages.errorCode3000));
        break;
      case 3002:
        error(t(i18nKey.common.apiErrorMessages.errorCode3002));
        break;
      case 7001:
        error(t(i18nKey.common.apiErrorMessages.errorCode7001));
        break;
      default:
        error(t(i18nKey.common.apiErrorMessages.errorCodeUnknown));
        break;
    }
  };

  return {
    success,
    error,
    errorByStatusCode,
  };
};

export default useMessage;
